/**
 * @expFlag public-redirect-to-download
 * @ticket CLOUDWEB-20088
 * @file
 */
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_PHONE_BROWSER, IS_PUBLIC, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

export const abPublicRedirectToDownload: 'a' | 'b' | undefined = getFeature('public-redirect-to-download');

export const isPublicRedirectToDownloadExp = IS_PUBLIC && !IS_WEBVIEW && IS_PHONE_BROWSER && abPublicRedirectToDownload === 'a';

export const isPublicRedirectToDownloadControl = IS_PUBLIC && !IS_WEBVIEW && IS_PHONE_BROWSER && abPublicRedirectToDownload === 'b';

export const publicRedirectToDownloadExpLink = 'https://trk.mail.ru/c/mgkol7';

export const publicRedirectToDownloadControlLink = 'https://trk.mail.ru/c/zvbau8';
